/* ============================================
   THE WORLD WANDERERS - Shopify Theme JS
   Theme Author: Mohamed Shaheen (work.mshaheen@gmail.com)
   ============================================ */

function initTheme() {

    // ── Navbar scroll effect ──
    const navbar = document.querySelector('.navbar');
    if (navbar) {
        const handleScroll = () => navbar.classList.toggle('scrolled', window.scrollY > 60);
        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll();
    }

    // ── Mobile nav toggle ──
    const toggle = document.querySelector('.mobile-toggle');
    const navLinks = document.querySelector('.nav-links');
    if (toggle && navLinks) {
        toggle.addEventListener('click', () => {
            navLinks.classList.toggle('active');
            toggle.classList.toggle('open');
            document.body.style.overflow = navLinks.classList.contains('active') ? 'hidden' : '';
        });
        navLinks.querySelectorAll('a').forEach(link => {
            link.addEventListener('click', () => {
                navLinks.classList.remove('active');
                toggle.classList.remove('open');
                document.body.style.overflow = '';
            });
        });
    }

    // ── Scroll reveal animations ──
    initRevealAnimations();

    // ── Counter animation ──
    initCounters();

    // ── Smooth anchor scroll ──
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                e.preventDefault();
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    });

    // ── Destination filter ──
    initDestinationFilter();

    // ── Parallax for hero image ──
    const heroImg = document.querySelector('.hero-image-main img');
    if (heroImg && window.innerWidth > 768) {
        window.addEventListener('scroll', () => {
            const scroll = window.scrollY;
            if (scroll < window.innerHeight) {
                heroImg.style.transform = `scale(1.02) translateY(${scroll * 0.04}px)`;
            }
        }, { passive: true });
    }

    // ── Expanding destination cards ──
    initExpandingCards();
}

function initRevealAnimations() {
    const reveals = document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .stagger-children');
    if (!reveals.length) return;
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(el => observer.observe(el));
}

function initCounters() {
    const counters = document.querySelectorAll('[data-count]');
    if (!counters.length) return;
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const el = entry.target;
                const target = parseInt(el.dataset.count);
                const suffix = el.dataset.suffix || '';
                const prefix = el.dataset.prefix || '';
                let current = 0;
                const step = Math.max(target / 50, 1);
                const timer = setInterval(() => {
                    current += step;
                    if (current >= target) { current = target; clearInterval(timer); }
                    el.textContent = prefix + Math.floor(current).toLocaleString() + suffix;
                }, 30);
                observer.unobserve(el);
            }
        });
    }, { threshold: 0.5 });
    counters.forEach(el => observer.observe(el));
}

function initDestinationFilter() {
    const filterBtns = document.querySelectorAll('.filter-btn');
    const destCards = document.querySelectorAll('.dest-card[data-category]');
    if (!filterBtns.length) return;
    filterBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            filterBtns.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            const filter = btn.dataset.filter;
            destCards.forEach(card => {
                const show = filter === 'all' || card.dataset.category === filter;
                card.style.display = show ? '' : 'none';
            });
        });
    });
}

function initExpandingCards() {
    const expandCards = document.querySelectorAll('.dest-expand-card');
    if (!expandCards.length) return;

    expandCards.forEach(card => {
        card.addEventListener('mouseenter', () => {
            expandCards.forEach(c => c.classList.remove('active'));
            card.classList.add('active');
        });
        card.addEventListener('click', () => {
            if (!card.classList.contains('active')) {
                expandCards.forEach(c => c.classList.remove('active'));
                card.classList.add('active');
            }
        });
    });

    let autoCycle;
    const row = document.querySelector('.dest-expand-row');
    const startCycle = () => {
        let idx = 0;
        autoCycle = setInterval(() => {
            idx = (idx + 1) % expandCards.length;
            expandCards.forEach(c => c.classList.remove('active'));
            expandCards[idx].classList.add('active');
        }, 3500);
    };

    if (row) {
        startCycle();
        row.addEventListener('mouseenter', () => clearInterval(autoCycle));
        row.addEventListener('mouseleave', () => { clearInterval(autoCycle); startCycle(); });
    }
}

// ── Init on DOM ready ──
document.addEventListener('DOMContentLoaded', initTheme);

// ── Shopify Theme Editor support ──
document.addEventListener('shopify:section:load', () => {
    initRevealAnimations();
    initExpandingCards();
    initCounters();
    initDestinationFilter();
});

// CSS animation keyframe for filter
const _s = document.createElement('style');
_s.textContent = '@keyframes fadeIn{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}';
document.head.appendChild(_s);
